import { render, staticRenderFns } from "./VisorPDF.vue?vue&type=template&id=20038666&scoped=true&"
import script from "./VisorPDF.vue?vue&type=script&lang=js&"
export * from "./VisorPDF.vue?vue&type=script&lang=js&"
import style0 from "./VisorPDF.vue?vue&type=style&index=0&id=20038666&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20038666",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QIcon,QTooltip});
